export default {"src":"/_next/static/media/new.95fd30c3.svg","height":16,"width":30,"blurWidth":0,"blurHeight":0};